module.exports = __webpack_public_path__ + "img/mammut-mobile_884842596fdf9c0b8535aafee91749dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/mammut-mobile.jpg
// module id = 284
// module chunks = 0